<div class="event-badge">
  <!-- <mat-icon class="service-badge__icon" [svgIcon]="'services:' + service"></mat-icon> -->
  <span class="event-badge__text">{{ text }}</span>
</div>
